module.exports = {"230903011":"桃东街道","230903012":"桃南街道","230903013":"桃西街道","230903014":"桃北街道","230903015":"桃源街道","230903016":"桃山街道","230903100":"万宝河镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230903.json
// module id = 867
// module chunks = 0